// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "input-r-YUx";
var _4 = "input_withoutPlaceholder-1tzoW";
var _5 = "input_departure-3olTr";
var _6 = "input_arrival-PS34V";
var _7 = "switcher-343Vq";
var _8 = "switcher_highlighted-2Nkpe";
var _9 = "switcher_alternative-3Oehp";
var _a = "input_icon-3AZFT";
var _b = "autocomplete_alternative-1p4d8";
var _c = "autocomplete-kxwgB";
export { _1 as "__esModule", _2 as "mobile", _3 as "input", _4 as "input_withoutPlaceholder", _5 as "input_departure", _6 as "input_arrival", _7 as "switcher", _8 as "switcher_highlighted", _9 as "switcher_alternative", _a as "input_icon", _b as "autocomplete_alternative", _c as "autocomplete" }
export default { "__esModule": _1, "mobile": _2, "input": _3, "input_withoutPlaceholder": _4, "input_departure": _5, "input_arrival": _6, "switcher": _7, "switcher_highlighted": _8, "switcher_alternative": _9, "input_icon": _a, "autocomplete_alternative": _b, "autocomplete": _c }
